import { render } from "./UserListMenuVersion.vue?vue&type=template&id=cb6eeb7a&scoped=true"
import script from "./UserListMenuVersion.vue?vue&type=script&lang=js"
export * from "./UserListMenuVersion.vue?vue&type=script&lang=js"

import "./UserListMenuVersion.vue?vue&type=style&index=0&id=cb6eeb7a&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6eeb7a"]])

export default __exports__